import axios from "axios";
import CurrencyFormat from "react-currency-format";
import React, { useState, useEffect, useContext } from "react";
import "./admin.css";
import { StateContext } from "../../App";

function Customers() {
  const { state, dispatch } = useContext(StateContext);

  const [users, setUsers] = useState([]);
  const [oneUser, setOneUser] = useState(null);
  const deposits = oneUser && oneUser.deposit

  // console.log("the one user ==", oneUser)
  console.log("the one user deposits ==", deposits)


  // SUMATION FUNC OR Total Fuction!
  const totalDeposits = oneUser && oneUser.deposit.reduce((acc, elem) => {

    return acc + elem;
    
  }, 0);

  const totalPayouts = oneUser && oneUser.payouts.reduce((acc, elem) => {

    return acc + elem;
    
  }, 0);
  


  const fetchCustomers = () => {
    dispatch({ type: "SET_LOADING", payload: true });

    axios
      .get("/admin/all-customers")
      .then((result) => {
        // console.log(result);
        // console.log(result.data);
        setUsers(result.data);

        dispatch({ type: "SET_LOADING", payload: false });
      })
      .catch((error) => {
        console.log("ERR! Getting All Customers", error);
        setUsers([]);

        dispatch({ type: "SET_LOADING", payload: false });
      });
  }

  useEffect(() => {
    
    fetchCustomers();
    
  }, []);

  const deleteCustomer = (id) => {
    const user_response = window.confirm(
      'You are about to delete a Customer click "OK" to continue with this task! '
    );

    if (user_response) {
      dispatch({ type: "SET_LOADING", payload: true });

      axios
        .delete(`/admin/customer/${id}`)
        .then((result) => {
          console.log("RESPONSE!! for Delete request", result);
          console.log("RESPONSE!! for Delete request", result.data);
          console.log("RESPONSE!! for Delete request", result.data.msg);

          dispatch({ type: "SET_LOADING", payload: false });
          result.data && alert("Customer has been deleted successfully!");
          result.data && fetchCustomers();
        })
        .catch((error) => {
          console.log("ERR! Deleting A User! ==>", error);
          dispatch({ type: "SET_LOADING", payload: false });
        });
    }
  };

  const tableData =
    users &&
    users.map((user) => {
      return (
        <tr key={user._id}>

      {/* Email */}
          <td>{user.email}</td>

      {/* Account Name */}
          <td>{user.name}</td>

      {/* Date Registered */}
          <td className="trim">{user.date}</td>

      {/* Delete Action Button here! */}
          <td>
            <button
              className="btn btn-large red darken-2"
              onClick={() => deleteCustomer(user._id)}
            >
              Delete
            </button>
          </td>

        </tr>
      );
    });

  const findUser = (e) => {
    e.preventDefault();
    dispatch({ type: "SET_LOADING", payload: true });

    const form = document.querySelector(".find-users-form");
    const searchQuery = form.searchQuery.value;
    console.log(searchQuery);

    axios
      .post("/admin/customer", { searchQuery })
      .then((result) => {
        console.log("form Submitting == >", result);
        setUsers([]);
        setOneUser(result.data);

        dispatch({ type: "SET_LOADING", payload: false });
      })
      .catch((error) => {
        console.log(error);
        dispatch({ type: "SET_LOADING", payload: false });
      });
  };

  return (
    <div className="Customers">
      <div className="customer-header indigo darken-2">
        <button
          data-target="slide-out"
          className="sidenav-trigger Button-menu hide-on-large-only"
        >
          <i className="fas fa-bars"></i>
        </button>
        <h1>Search customer</h1>
        <form onSubmit={findUser} className="find-users-form">
          <div className="row">
            <div className="col s12 m8 l6">
              <input
                type="text"
                name="searchQuery"
                placeholder="Enter Customer Email"
              />
            </div>
            <div className="col s12 m4 l3">
              <button>Find Customer</button>
            </div>
          </div>
        </form>
        {users && <h6>Number of customers - {users.length}</h6>}
      </div>

      <div className="container">
        <br />
        <br />
        <br />
        <br />
        <div className="card indigo darken-3">
          <div className="col s12 m12 l12 indigo darken-3">
            {
              users.length == 0 && oneUser == null && (<p>
                Sorry, cannot fetch customer records at this time,
                Or you have an empty customer record.
                Please refresh this app!
              </p>)
            }

            {
              users.length !== 0 && oneUser == null && (<table cellPadding="30" className="highlight">
                    <thead>
                      <tr>
                        <th data-field="Name">Email</th>

                        <th data-field="Email">Account Name</th>

                        <th data-field="Date">Date Registered</th>
                        <th data-field="Action red-text">Action</th>
                      </tr>
                    </thead>
                    <tbody>{tableData}</tbody>
                  </table>)
            }

            {
              users.length == 0 && oneUser !== null && (<div className="row indigo darken-3">
                  
                  <div className="col s6 m6 l6">
                    <div className="row indigo darken-3">
                    
                      <div className="col s12 m12 l12">
                        <span className="card-title">Name</span>
                        {oneUser && oneUser.name}
                      </div>
                    
                      <div className="col s12 m12 l12">
                        <span className="card-title">Email</span>
                        {oneUser && oneUser.email}
                      </div>
                      
                      <div className="col s12 m12 l12">
                        <span className="card-title">Wallet</span>
                        <CurrencyFormat
                            renderText={(value) => (
                              <>
                                <p>
                                  <strong>{value}</strong>
                                </p>
                              </>
                            )}
                            value={oneUser && oneUser.wallet}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            thousandSeparator={true}
                            displayType={"text"}
                            prefix={"$"}
                        />
                      </div>
                    
                      <div className="col s12 m12 l12">
                        <span className="card-title">Referral</span>
                        {oneUser && oneUser.referral}
                      </div>
                      
                      <div className="col s12 m12 l12">
                        <span className="card-title">Username</span>
                        {oneUser && oneUser.username}
                      </div>
                      
                      <div className="col s12 m12 l12">
                        <span className="card-title">Bonus</span>
                        <CurrencyFormat
                            renderText={(value) => (
                              <>
                                <p>
                                  <strong>{value}</strong>
                                </p>
                              </>
                            )}
                            value={oneUser && oneUser.bonus}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            thousandSeparator={true}
                            displayType={"text"}
                            prefix={"$"}
                        />
                      </div>
                      <div className="col s12 m12 l12">
                        <span className="card-title">Deposits</span>
                        <CurrencyFormat
                            renderText={(value) => (
                              <>
                                <p>
                                  <strong>{value}</strong>
                                </p>
                              </>
                            )}
                            value={oneUser && totalDeposits}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            thousandSeparator={true}
                            displayType={"text"}
                            prefix={"$"}
                        />
                      </div>
                      
                      <div className="col s12 m12 l12">
                        <span className="card-title">Payouts</span>
                        <CurrencyFormat
                            renderText={(value) => (
                              <>
                                <p>
                                  <strong>{value}</strong>
                                </p>
                              </>
                            )}
                            value={oneUser && totalPayouts}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            thousandSeparator={true}
                            displayType={"text"}
                            prefix={"$"}
                        />
                      </div>

                      <div className="col s12 m12 l12">
                        <span className="card-title">Date Registered</span>
                        {oneUser && oneUser.date}
                      </div>
                      
                      <div className="col s12 m12 l12">
                        <button
                          onClick={() => deleteCustomer(oneUser && oneUser._id)}
                          className="red darken-3 btn black-text text-darken-4"
                        >
                          Delete Account
                        </button>
                      </div>
                      
                    </div>
                </div>
                {/* End! */}

              </div>)

        }    
          </div>
        </div>
      </div>
    </div>
  );
}

export default Customers;
